import React from 'react';
import { Paper } from 'features/app/components/Paper';
import { useTranslation } from 'hooks/useTranslation';
import { useStyles } from 'features/subscription/components/MySubscription/style';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { green, grey } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/styles';
import { setSelectedSubscriptionPlansAction } from 'features/subscription/redux/action';
import { useDispatch } from 'react-redux';
import { SelectInput } from 'features/app/components/SelectInput';

type PlanTypeProps = {
  onChangeCurrency: (value: string) => void;
  currency: string;
};

export const PlanType: React.FC<PlanTypeProps> = ({ onChangeCurrency, currency }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation('subscription');
  const currencyOptions = [
    { value: 'usd', label: 'USD' },
    { value: 'sar', label: 'SAR' },
  ];

  const GreenRadio = withStyles({
    root: {
      color: grey[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })(props => <Radio color="default" {...props} />);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    dispatch(setSelectedSubscriptionPlansAction(value));
  };

  return (
    <Paper className={classes.root}>
      <h4 className={classes.title}>{t('noSubscription.subscribeNow')}</h4>
      <div className={classes.rightBock}>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          defaultValue="year"
          onChange={handleChange}
        >
          <FormControlLabel
            className={classes.label}
            name="annual_plan"
            value="year"
            control={<GreenRadio />}
            label={t('annualPlan')}
          />
          <FormControlLabel name="monthly_plan" value="month" control={<GreenRadio />} label={t('monthlyPlan')} />
        </RadioGroup>
        <SelectInput
          onChange={selected => {
            onChangeCurrency((selected as { value: string; label: string }).value);
          }}
          className={classes.currencySelectInput}
          name="currency"
          value={currencyOptions.find(({ value }) => currency === value)}
          options={currencyOptions}
          defaultValue={{ value: 'usd', label: 'USD' }}
        />
      </div>
    </Paper>
  );
};
